import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { SystemGlobalsService } from '../../system-globals.service';
//import * as $ from 'jquery';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FroalaService } from '../froala.service';
declare var $: any;

@Component({
  selector: 'froala-editor',
  templateUrl: './froala-editor.component.html',
  styleUrls: ['./froala-editor.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: FroalaEditorComponent,
    multi: true
  }]
})
export class FroalaEditorComponent extends BaseControl {
  froalaKey: string = '';
  options: Object;
  forceUpdate: string = '';

  private editor;
  private editorControls: Object;

  @Input() label: string = '';
  @Input() customOptions: Object;
  @Input() customToolbar: string[];
  @Input() placeholder: string

  static readonly baseToolbarButtons: string[] = ['fullscreen', '|', 'fontFamily', '|', 'fontSize', '|', 'textAttributes', 'textColor', 'specialCharacters', 'selectAll', 'clearFormatting', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertHR', 'insertLink', 'insertTable', 'editorSettings', 'undo', 'redo', '|', 'html', 'preview', 'help'];

  static readonly defaultEditorOptions: Object = {
    shortcutsEnabled: ['bold', 'italic', 'underline', 'undo', 'redo'],
    fontFamilySelection: true,
    fontFamilyDefaultSelection: 'Arial',
    fontSizeSelection: true,
    fontSize: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '36', '48', '60', '72', '96'],
    fontSizeDefaultSelection: '14',
    colorsText: ['#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
    '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000',
    '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF',
    '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', '#0000FF'],
    tabSpaces: 8,
    tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', 'tableStyle', '-', 'tableCells', 'tableCellBackground', 'tableCellVerticalAlign', 'tableCellHorizontalAlign', 'tableCellStyle'],
    tableStyles: {
        'solid-borders' : 'Solid Borders',
        'dashed-borders' : 'Dashed Borders',
        'alternate-rows' : 'Alternate Rows',
        'cell-padding': 'Cell Padding',
        'fixed-table' : 'Full width',
        'autofit-right-table': 'Maximum Left Column'
    },
    imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageAlt', 'customImageStyle', 'quickResize', 'imageTUI'],
    charCounterCount: false,
    heightMin: 250,
    imageDefaultAlign: 'left',
    imageDefaultDisplay: 'block',
    imageMove: true,
    imageSplitHTML: true,
    imageUploadParam: 'file[]',
    //imageUploadURL: '/components/media-library/server/index.php?module_id=0&network_id=' + globals.constants._g_networkID + '&network_path=modules&module_path=images&image_type=contentImage&upload_type=drag',
    imageUploadMethod: 'POST',
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imagePasteProcess: true,
    imageDefaultWidth: "auto",
    videoEditButtons: ['videoRemove', 'videoDisplay', 'videoAlign'],
    htmlUntouched: true,
    linkAlwaysBlank: true,
    htmlRemoveTags: ['script'],
    placeholderText : "",
    spellcheck: true,
    attribution: false,
  };

  uploadPdfUrl: string = '';
  uploadImageUrl: string = '';
  uploadLinkImageUrl: string = '';
  uploadVideoUrl: string = '';

  constructor(private globals: SystemGlobalsService, private froalaService: FroalaService, private changeDetectorRef: ChangeDetectorRef,) {
    super();

    this.uploadPdfUrl = '/main/documents/media?callback=uploadEmbedFile&path=Reference%20Library';
    this.uploadImageUrl = '/main/documents/media?callback=insertImage&path=Media%20Library';
    this.uploadLinkImageUrl = '/main/documents/media?callback=insertImage&path=Media%20Library';
    this.uploadVideoUrl = '/main/documents/media?callback=videoFileCallback&path=Media%20Library';

    // this.uploadPdfUrl = '/components/media-library/pdf/add.php?module_id=0&network_id=' + globals.constants._g_networkID;
    // this.uploadImageUrl = '/components/media-library/images/add.php?module_id=0&network_id=' + globals.constants._g_networkID + '&network_path=modules&sendDetails=1&callback=insertImage&image_type=contentImage';
    // this.uploadLinkImageUrl = '/components/media-library/images/add.php?module_id=0&network_id=' + globals.constants._g_networkID + '&network_path=modules&sendDetails=1&callback=insertLinkImage&image_type=linkImage';
    // this.uploadVideoUrl = '/components/media-library/video/add.php?module_id=0&network_id=' + globals.constants._g_networkID + '&network_path=video&showProgress=true';

    this.froalaKey = globals.constants.froalaKey;
  }

  buildOptions() {
    if (this.customOptions) this.options = this.customOptions;
    else {
      this.options = FroalaEditorComponent.defaultEditorOptions;
      this.options['imageUploadURL'] = '/files/uploadFile?searchFolder=Media%20Library&linkOnly=true';
    }

    if (this.customToolbar && this.customToolbar.length) {
      this.options['toolbarButtons'] = this.customToolbar;
      this.options['toolbarButtonsMD'] = this.customToolbar;
      this.options['toolbarButtonsSM'] = this.customToolbar;
      this.options['toolbarButtonsXS'] = this.customToolbar;
      this.options['placeholderText'] = this.placeholder;
    }
    else {
      this.options['toolbarButtons'] = FroalaEditorComponent.baseToolbarButtons;
      this.options['toolbarButtonsMD'] = FroalaEditorComponent.baseToolbarButtons;
      this.options['toolbarButtonsSM'] = FroalaEditorComponent.baseToolbarButtons;
      this.options['toolbarButtonsXS'] = FroalaEditorComponent.baseToolbarButtons;
    }

    this.options['key'] = this.froalaKey;
    this.options['attribution'] = false;

    this.options['uploadPdfUrl'] = this.uploadPdfUrl;
    this.options['uploadImageUrl'] = this.uploadImageUrl;
    this.options['uploadLinkImageUrl'] = this.uploadLinkImageUrl;
    this.options['uploadVideoUrl'] = this.uploadVideoUrl;

    this.options['events'] = {
      contentChanged: () => this.updateContent()
    };
  }

  updateContent() {
    this.value = this.editor.html.get();
    this.updateValue();
  }

  ngOnInit() {
    this.froalaService.extendFunctionality();
    this.buildOptions();
  }

  initialize(editorControls) {
    this.editorControls = editorControls;
    this.editorControls['initialize'](this.options);
    this.editor = this.editorControls['getEditor']();
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.value = this.value + ' ';
      this.changeDetectorRef.detectChanges();
      this.forceUpdate = Date.now().toString();
    }, 500);
  }

}
